(function () {
    'use strict';

    var STORAGE_KEY = 'cm-global-alert-dismissed';
    var alertEl = document.getElementById('global-alert');

    if (!alertEl) {
        return;
    }

    function simpleHash(str) {
        var hash = 0;
        var i;

        for (i = 0; i < str.length; i++) {
            hash = ((hash << 5) - hash) + str.charCodeAt(i);
            hash |= 0;
        }

        return String(hash);
    }

    function getAlertId() {
        var messageEl = alertEl.querySelector('.global-alert__message');
        var ctaEl = alertEl.querySelector('.global-alert__cta');
        var message = messageEl ? messageEl.textContent.trim() : '';
        var ctaHref = ctaEl ? (ctaEl.getAttribute('href') || '') : '';

        return simpleHash((message + '|' + ctaHref).toLowerCase());
    }

    function hideAlert() {
        alertEl.classList.add('global-alert--dismissed');
        alertEl.setAttribute('hidden', '');
    }

    function showAlert() {
        alertEl.classList.remove('global-alert--dismissed');
        alertEl.removeAttribute('hidden');
    }

    function dismissAlert() {
        try {
            localStorage.setItem(STORAGE_KEY, getAlertId());
        } catch (error) {
            // localStorage may be unavailable in private browsing.
        }

        hideAlert();
    }

    function init() {
        var dismissBtn = alertEl.querySelector('.global-alert__dismiss');
        var storedId;

        try {
            storedId = localStorage.getItem(STORAGE_KEY);
        } catch (error) {
            storedId = null;
        }

        if (storedId === getAlertId()) {
            hideAlert();
            return;
        }

        showAlert();

        if (dismissBtn) {
            dismissBtn.addEventListener('click', dismissAlert);
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
}());
